/** Paintbrush ID auth — always on for PHA web. */
export const PAINTBRUSH_ID_URL = (
  process.env.VUE_APP_PAINTBRUSH_ID_URL || 'https://id.paintbrushoutdoors.com'
).replace(/\/$/, '')

export const DEFAULT_OAUTH_PROVIDER = 'google'

export const ACCESS_TOKEN_HEADER = 'X-PB-Access-Token'

export function authServiceUrl (path) {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${PAINTBRUSH_ID_URL}${normalized}`
}

export function centralLoginUrl (provider, returnTo) {
  return `${PAINTBRUSH_ID_URL}/api/oauth/login/${provider}?redirect=${encodeURIComponent(returnTo)}`
}

export function signInEntryUrl (returnTo, provider = DEFAULT_OAUTH_PROVIDER) {
  return centralLoginUrl(provider, returnTo)
}

export function appSiteUrl (path = '/') {
  if (typeof window === 'undefined') return path
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${window.location.origin}${normalized}`
}
